/* The file contents for the current environment will overwrite these during build.
   The build system defaults to the dev environment which uses `environment.ts`, but if you do
   `ng build --env=prod` then `environment.prod.ts` will be used instead.
   The list of which env maps to which file can be found in `.angular-cli.json`. */

import { sceconfig } from "sce-core";
const feedbackDisplayId = window["env"]["feedbackDisplayId"] || '1234175055437234176';
export const environment = {
  production: true,
  logger: "console",

  baseUrlUI: sceconfig.wms.baseUrlUI,
  wmsApiBaseUrl:
    window["env"]["wmsApiBaseUrl"] || "http://localhost:8080/lfcoreservice/",
  commonApiBaseUrl : window["env"]["commonApiBaseUrl"] || "http://localhost:8080/scecommon/",
  growthbookClientKey: window["env"]["growthbookClientKey"] || 'sdk-kwwtLzwlFXEoiMR7',
  growthbookHostApi: window["env"]["growthbookHostApi"] || 'https://growthbook-proxy.fbm.maersk.com/',
  anchorFeedbackFormBaseUrl : window['env']['anchorFeedbackBaseUrl'] || 'https://insightshub-api.maersk-digital.net/api/feedbacks/',
  feedbackFormId: window['env']['feedbackFormId'] || 'e0eb3a77-1dd3-474c-99b1-a299121d32b2',
  susFeedbackFormId: window['env']['susFeedbackFormId'] || 'c3f7f59f-831d-455c-ab71-2dca2a6ce71d',
  anchorFeedbackURL: window["env"]["anchorFeedbackURL"] ||'https://insightshub.maersk-digital.net/embed/embed.js',
  feedbackDisplayId,
  feedbackEmailURL: window["env"]["feedbackEmailURL"] || `https://insightshub-api.maersk-digital.net/api/feedbacks/${feedbackDisplayId}/author/`,
  ptwClientUrl: window["env"]["ptwClientUrl"] || 'https://cdt-wms.fulfillment.maersk.com/ptw',
  // wmsApiBaseUrl: 'https://scedev.lflogistics.net/lfcoreservice/'
  // wmsApiBaseUrl: 'https://scesit.lflogistics.net/lfcoreservice/',
  // wmsApiBaseUrl: 'https://sceuat.lflogistics.net/lfcoreservice/'
  // wmsApiBaseUrl: 'http://172.29.175.159:8080/lfcoreservice/' // anoop
  // wmsApiBaseUrl: 'http://172.29.175.104:8080/lfcoreservice/' // rakshana
  // wmsApiBaseUrl: 'http://172.29.175.171:8080/lfcoreservice/'// kavya
  // wmsApiBaseUrl: 'http://172.29.175.103:8080/lfcoreservice/' // jesna
  //  wmsApiBaseUrl: 'http://172.29.175.110:8080/lfcoreservice/' // vysakh
  // wmsApiBaseUrl: 'http://172.29.175.133:8080/lfcoreservice/' // Anu
  //wmsApiBaseUrl: 'http://172.29.175.134:8080/lfcoreservice/' // neema
};



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/environments/environment.ts